import { Component, OnInit } from '@angular/core';
import { TableSkeletonService } from './table-skeleton.service';

@Component({
    selector: 'app-table-skeleton',
    templateUrl: './table-skeleton.component.html',
    styleUrls: ['./table-skeleton.component.css'],
})
export class TableSkeletonComponent implements OnInit {
    public readonly bgColor: string = 'var(--color-fui-surf-container-high)';

    constructor(public tableSkeletonService: TableSkeletonService) {}

    ngOnInit(): void {}
}
